import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/Shared/Header";
import ClientInfo from "../../components/Client/ClientInfo";
import { getClientInfo } from "../../Utils/client/client";
import Loading from "../../components/Shared/Loading";
import { useSelector } from "react-redux";



const ClientPage = () => {
  const id = useSelector((state) => state.user.userInfo.user_id);
  const [clientInfo, setClientInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchClientData = async () => {
    setLoading(true);
    try {
      const res = await getClientInfo(id);
      setClientInfo(res.data);
    } catch (error) {
      console.error("Error fetching client data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClientData();
  }, [id]);

  if (loading) return <Loading />;


  return (
    <div className="bg-white min-h-screen">
      <Header title="Profil client" />
      { clientInfo ?
        <div className="container mx-auto p-4">
        <ClientInfo clientInfo={clientInfo} />
      </div>
      : <div className="text-center text-lg font-bold text-red-500 mt-4">
        Erreur lors du chargement des données
        </div>
      }
    </div>
  );
};

export default ClientPage;